import React, { Component } from "react"
import {FormTable} from './FormTable'


export class Form extends Component {

    constructor(props) {
        super(props)
        this.state = {
            datas: []
        }
    }
    componentDidMount(){
    }
    render() {
        const {datas} = this.state
        return (
            <div className="main-content">
                <div className="my-4">
                    <div id="example_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer shadow-lg p-3 mb-5 bg-white rounded">
                    <table className="table example" id="example">
                        <thead>
                            <tr>
                                <th scope="col">Гүйлгээний дугаар</th>
                                <th scope="col">Дүн</th>
                                <th scope="col">Огноо</th >
                                <th scope="col">Огноо</th >
                                <th scope="col">Огноо</th >
                            </tr>
                        </thead>
                        <tbody>
                            {datas.map((huulga, idx) =>
                                <FormTable key = {idx} values={huulga}></FormTable>
                            )}
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
        )

    }

}
